import nccImg1 from '../../../assets/images/Clubs/ncc/ncc-1.webp';
import nccImg2 from '../../../assets/images/Clubs/ncc/ncc-2.webp';
import nccImg3 from '../../../assets/images/Clubs/ncc/ncc-3.webp';
import nccImg4 from '../../../assets/images/Clubs/ncc/ncc-4.webp';
import nccHero from '../../../assets/images/Clubs/ncc/ncc-1.webp';

export const nccData = {
    id: "ncc",
    name: "National Cadet Corps (NCC)",
    category: "NCC",
    tagline: "Unity and Discipline",
    about: "Developing character, comrade-ship, discipline, leadership, secular-outlook, spirit of adventure and ideals of selfless service.",
    objectives: [
        "To Create a Human Resource of Organized, Trained and Motivated Youth.",
        "To Provide Leadership in all Walks of life and be Always Available for the Service of the Nation.",
        "To Provide a Suitable Environment to Motivate the Youth to Take Up a Career in the Armed Forces."
    ],
    coordinators: [
        { name: "NCC Officer", designation: "Coordinator", dept: "Various", phone: "" }
    ],
    activitiesSummary: { "2025-26": 6, "2024-25": 12, "2023-24": 15 },
    eventDetails: [],
    gallery: [nccImg1, nccImg2, nccImg3, nccImg4],
    heroImage: nccHero,
    motto: "Unity, Discipline & Leadership",
    generalInfo: "The National Cadet Corps (NCC) has its genesis in the 'University Corps', which was created under the Defence Act, 1917 with the object to make up the shortage of the Army. In 1920, when the Indian Territorial Act was passed, The 'University Corps' was replaced by the 'University Training Corps (UTC)' In 1942, the UTC was renamed as the 'University Officers Training Corps' (UOTC). The need to create a youth organisation at National level to train the young boys and girls to be better citizens and future leaders of our great country in all walks of life, including Defence forces, was rightly realized by our leaders. A Committee under Pandit HN Kunzru was set up in 1946 at the behest of our first Prime Minister,Pandit Jawaharlal Nehru. The NCC came into existence on 16th July, 1948 under the NCC Act XXXVI of 1948 under the Ministry of Defence (MOD).",
    generalImage: nccImg1,
    essentialLinks: [
        { title: "INDIAN AIRFORCE", link: "https://indianairforce.nic.in/" },
        { title: "INDIAN DEFENCE RESEARCH WING", link: "https://idrw.org/" },
        { title: "NCC ONLINE ENROLLMENT", link: "https://nccauto.gov.in/enrolment" },
        { title: "MINISTRY OF DEFENCE", link: "https://www.mod.gov.in/" },
        { title: "NCC INDIA", link: "https://indiancc.nic.in/" },
        { title: "IMA", link: "https://indianarmy.nic.in/" }
    ],
    studyMaterials: [
        { title: "BLUE BOOK", link: "https://drive.google.com/file/d/1xOMQctwQqFOmgdT1Ot-JDa3Lqgq2gtMG/view" },
        { title: "RED BOOK", link: "https://cdnbbsr.s3waas.gov.in/s307811dc6c422334ce36a09ff5cd6fe71/uploads/2020/01/2020011529.pdf" },
        { title: "Health & Hygiene", link: "https://drive.google.com/file/d/1XqDsdPMyIZrGHOtFZMElWjgy5IsBWHa2/view" },
        { title: "VIRUS - SOP", link: "https://drive.google.com/file/d/1kcwJ_TZOEElPyXCnzWpqJK15c3pqP7nt/view" },
        { title: "PPT", link: "https://drive.google.com/drive/folders/1J7wb0whCToNB0ShPtyP1h336c6Gsy3q-" },
        { title: "Common Subject", link: "https://drive.google.com/file/d/1EULsAscAsGqCHXDPx8LMRsTn4etiqVIo/view" },
        { title: "OBSTACLES TRAINING", link: "https://drive.google.com/file/d/1Jhgj7PcSxb2q7t3Iv1Cc-Icm3-EdT-R8/view" },
        { title: "WT & Drill", link: "https://drive.google.com/drive/folders/19HeaKSyUPDFF3HhCufrlcDZ2IMmxq2gq" }
    ],
    detailedHistory: {
        aimsTitle: "Aims",
        aimsIntro: "The aims of NCC as approved by MOD in Mar 2001 are as under:-",
        aims: [
            "To develop character, comradeship, discipline, leadership, secular outlook, spirit of adventure, sportsmanship and ideals of selfless service among the youth of the country.",
            "To create a human resource of organized, trained and motivated youth, to provide leadership in all walks of life and always be available for the service of the nation.",
            "To provide a suitable environment to motivate the youth to take up a career in the Armed Forces."
        ],
        airWing: {
            title: "About KEC NCC - Air Wing",
            content: "KEC NCC Air Wing was inaugurated by Wg Cdr K. Jayandan, the Commanding Officer, 5(TN) AIR SQN (TECH) NCC , SALEM on 18/09/2019 . Thiru P. Sachithanandan , the Correspondent, Kongu Engineering College presided over the inaugural and Dr.V. Balusamy, the Principal, Kongu Engineering College delivered the felicitation address. The Welcome address was delivered by Major Dr P.S. Raghavendran , Company Commander, Kongu Engineering College. Mr. A. Jeevanantham , the then Care Taker of NCC Air Wing organized the Air Wing Inaugral program."
        }
    },
    achievements: "The spirit of selfless service and leadership is reflected through the consistent efforts of our volunteers. Students actively organize impactful initiatives such as blood donation camps, tree plantation drives, and health awareness programs. Participation in rural development activities and social outreach has strengthened responsibility, teamwork, and civic sense. These accomplishments showcase a strong commitment to creating a positive and lasting impact on society.",
    achievementsLink: "https://docs.google.com/spreadsheets/d/19TM-cnnBTUwHWUBgxPSOsM-9Up8TuakDiy-doSwW4dQ/edit?gid=0#gid=0",
    cadetsCorner: {
        title: "Cadets Corner",
        items: [
            { name: "Parade Schedule", icon: "schedule", link: "https://drive.google.com/drive/u/0/folders/12Be3ULa7S-eFBtWv1igx2j8756LGtGLU" },
            { name: "Parade Attendance", icon: "attendance", link: "https://drive.google.com/drive/u/0/folders/1NKxDNnH2GwE96OtzSaD3apvdRAbFUpry" },
            { name: "Parade Proof", icon: "proof", link: "https://drive.google.com/drive/u/0/folders/1Q8zVlq7sv6W7rf0LpaGnPL2CnSqhV-EM" },
            { name: "OD", icon: "od", link: "https://drive.google.com/drive/u/0/folders/1VxyvJD_43Sscmvbizog-Ye4y9qKq2ZSl" },
            { name: "Long Roll", icon: "roll", link: "https://docs.google.com/spreadsheets/d/10WW0wmRMrt7xdvFLLik0Rjag7uWWqn5k7KNWg-XTt-w/edit?gid=1812953248#gid=1812953248" },
            { name: "Circular", icon: "circular", link: "https://drive.google.com/drive/u/0/folders/1m_bN-YhwMDzs86lxVKJ16up_AUxyrmfb" }
        ]
    },
    nominalRoll: [
        { 
            batch: "2019-22", 
            cadets: [
                { name: "Dharani Sanjay B", image: "Dharani Sanjay B.webp" },
                { name: "Ganesh Aravind G", image: "Ganesh Aravind G.webp" },
                { name: "Gokulnath K", image: "Gokulnath K.webp" },
                { name: "Jidhesh P", image: "Jidhesh P.webp" },
                { name: "Kavin N S", image: "Kavin N S.webp" },
                { name: "Mithila S K", image: "Mithila S K.webp" },
                { name: "Mohith T", image: "Mohith T.webp" },
                { name: "Pooventhan D", image: "Pooventhan D.webp" },
                { name: "Rinisha K", image: "Rinisha K.webp" },
                { name: "Sanjanaa N", image: "Sanjanaa N.webp" },
                { name: "Sridevi M", image: "Sridevi M.webp" },
                { name: "Srinithi K", image: "Srinithi K.webp" },
                { name: "Vinothini P", image: "Vinothini P.webp" },
                { name: "Ilamathi", image: "ilamathi.webp" },
                { name: "Jeevika", image: "jeevika.webp" },
                { name: "Mathumithra", image: "mathumithra.webp" },
                { name: "Nithish", image: "nithish.webp" }
            ]
        },
        { 
            batch: "2020-23", 
            cadets: [
                { name: "Aheilan M", image: "AHEILAN M.webp" },
                { name: "Akshitha A", image: "AKSHITHA A.webp" },
                { name: "Gokul S", image: "GOKUL S.webp" },
                { name: "Javin N T", image: "JAVIN N T.webp" },
                { name: "Keerthana P", image: "KEERTHANA P.webp" },
                { name: "Laavanya M", image: "LAAVANYA M.webp" },
                { name: "Mounisha L", image: "MOUNISHA L.webp" },
                { name: "Ranjith R", image: "RANJITH R.webp" },
                { name: "Ranjitha K", image: "RANJITHA K.webp" },
                { name: "Sathiswaran S", image: "SATHISWARAN S.webp" },
                { name: "Sheshathri D", image: "SHESHATHRI D.webp" },
                { name: "Sushma H", image: "SUSHMA H.webp" },
                { name: "Thejaswar M A", image: "THEJASWAR M A.webp" }
            ]
        },
        { 
            batch: "2021-24", 
            cadets: [
                { name: "Aheilan M", image: "AHEILAN M.webp" },
                { name: "Akshitha A", image: "AKSHITHA A.webp" },
                { name: "Alex Pandian C", image: "ALEX PANDIAN C.webp" },
                { name: "Daniel Amalesh C", image: "DANIEL AMALESH C.webp" },
                { name: "Devaprakash S", image: "DEVAPRAKASH S.webp" },
                { name: "Gokul S", image: "GOKUL S.webp" },
                { name: "Javin N T", image: "JAVIN N T.webp" },
                { name: "Keerthana P", image: "KEERTHANA P.webp" },
                { name: "Laavanya M", image: "LAAVANYA M.webp" },
                { name: "Mounisha L", image: "MOUNISHA L.webp" },
                { name: "Ranjith R", image: "RANJITH R.webp" },
                { name: "Sathiswaran S", image: "SATHISWARAN S.webp" },
                { name: "Sheshathri D", image: "SHESHATHRI D.webp" },
                { name: "Sushma H", image: "SUSHMA H.webp" },
                { name: "Thejaswar M A", image: "THEJASWAR M A.webp" }
            ] 
        },
        { 
            batch: "2022-25", 
            cadets: [
                { name: "Aakash A", image: "Aakash A.webp" },
                { name: "Abishek S", image: "Abishek S.webp" },
                { name: "Aswin Vishwaa K B", image: "Aswin Vishwaa K B.webp" },
                { name: "Bhobesh Adhithiyan SG", image: "BhobeshAdhithiyan SG.webp" },
                { name: "Dharaneeshver A E", image: "Dharaneeshver A E.webp" },
                { name: "Jaiveer Singh", image: "Jaiveer SinghJaiveer Singh.webp" },
                { name: "Jayandhan S", image: "Jayandhan S.webp" },
                { name: "Motheeshwaran K", image: "Motheeshwaran K.webp" },
                { name: "Santhosh S", image: "Santhosh S.webp" },
                { name: "Srisudharsan B", image: "Srisudharsan B.webp" }
            ]
 
        }
    ],
    bloggerUpdates: [
        { 
            title: "From Campus to Camp: A Cadet's Odyssey", 
            date: "April 15, 2026", 
            link: "#", 
            author: "Cdt. Arjun", 
            tag: "Life at KEC",
            summary: "Discover the transformation from a student to a disciplined cadet through the lens of rigorous field training and institutional values."
        }
    ],
    enrollment: {
        eligibility: "Open for 1st and 2nd year students with a passion for discipline and service.",
        process: "Physical fitness test followed by an interview and document verification.",
        formLink: "https://nccauto.gov.in/enrolment"
    }
};
